import * as Yup from "yup";
import checkout from "./form12";

const {
  formField12: { provisionLevel, amountSetAside },
} = checkout;

const validation12 = Yup.object().shape({
  [provisionLevel.name]: Yup.number().required(provisionLevel.errorMsg),
  [amountSetAside.name]: Yup.number().required(amountSetAside.errorMsg),
});

export default validation12;
